<script setup lang="ts">
import { getProductUrl } from "~/composables/useProductUrl";

const api = useApi();
const route = useRoute();
const productId = computed(() => route.params.id as string);

// Fetch product to determine the new URL
const { data: productData } = await useAsyncData(
    `product-redirect-${productId.value}`,
    () => api<any>(`/api/products/${productId.value}`),
);

const product = computed(() => productData.value?.product || null);

// Redirect to new SEO-friendly URL
if (product.value) {
    const newUrl = getProductUrl(product.value);
    if (newUrl !== `/produkt/${productId.value}`) {
        await navigateTo(newUrl, { redirectCode: 301 });
    }
}

// Fallback (Produkt ohne Slug/Kategorie ODER nicht gefunden): nicht indexieren.
useSeoMeta({ robots: "noindex, follow" });
</script>

<template>
    <ProductDetailPage v-if="productData" :product-data="productData" />
    <div v-else class="m-container py-16 text-center">
        <MIcon :size="64" color="grey-lighten-2" icon="package-variant-remove" class="mb-4" />
        <h2 class="text-h6 text-medium-emphasis mb-2">
            Produkt nicht gefunden
        </h2>
        <MBtn
            color="primary"
            variant="flat"
            to="/"
            class="text-none mt-4"
        >
            Zur Startseite
        </MBtn>
    </div>
</template>
